import { Alert, Table, TableColumnsType } from 'antd';
import { PRICING_ITEMS, PRICING_NOTICE, type PricingItem } from './pricingData';

const Pricing = () => {
  const columns: TableColumnsType<PricingItem> = [
    { title: '插件', dataIndex: 'optType' },
    {
      title: '价格',
      dataIndex: 'price',
      render: (text: number, record: PricingItem) => {
        return (
          <span>
            {text} 元/{record.unit}
            {record.memberPrices && (
              <div className="text-xs text-gray-400 mt-0.5">
                SVIP {record.memberPrices.svip} 元/{record.unit} · VIP {record.memberPrices.vip} 元/
                {record.unit}
              </div>
            )}
          </span>
        );
      },
    },
  ];
  return (
    <>
      <Alert message={PRICING_NOTICE} type="info" showIcon />
      <Table<PricingItem>
        size="small"
        className="mt-2"
        columns={columns}
        dataSource={PRICING_ITEMS}
        pagination={false}
      />
    </>
  );
};
export default Pricing;
